import { createTheme } from '@mui/material/styles';

// Base theme that both preview and full extend
const baseCardTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontWeight: 600,
                    borderRadius: '12px',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    WebkitFontSmoothing: 'subpixel-antialiased',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)',
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
    },
});

// Preview theme (used in DigitalCardPreview.js)
export const previewCardTheme = createTheme({
    ...baseCardTheme,
    card: {
        container: {
            maxWidth: '330px',
            margin: 'auto',
            height: '600px',
            boxSizing: 'border-box',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        profileImage: {
            size: '120px',
            border: '4px solid #ffffff',
            bottom: '-60px',
            padding: '2px',
            margin: '-6px'
        },
        companyLogo: {
            size: '45px',
            bottom: '-55px',
            padding: '4px',
            margin: '-4px',
            rightOffset: 'calc(50% - 75px)',
            leftOffset: '85px'
        },
        content: {
            marginTop: '60px',
            padding: '15px'
        },
        typography: {
            nameSize: '1.2rem',
            nameHeight: '28px',
            nameLineHeight: '28px',
            nameMarginBottom: '3px',

            pronounSize: '14px',
            pronounHeight: '20px',
            pronounLineHeight: '20px',
            pronounMarginTop: '6px',

            jobTitleSize: '1rem',
            jobTitleLineHeight: '1.4rem',

            locationSize: '0.9rem',
            locationLineHeight: '1.6rem',

            bioSize: '0.9rem',
            bioLineHeight: '1.4rem',
            bioMargin: {
                top: '1rem',
                bottom: '0.5rem'
            }
        },
        button: {
            fontSize: '1rem',
            padding: '0.5rem 0.8rem',
            letterSpacing: '0.028rem',
            marginTop: '15px'
        },
        links: {
            marginTop: 1.5,
            itemMargin: 1,
            itemMarginBottom: 0.8,
            iconSize: '45px',
            iconBorderRadius: '12px',
            iconPadding: '4px',
            leftIconSize: '35px',
            leftIconBorderRadius: '6px',
            titleFontSize: '10px',
            leftTitleFontSize: '12px',
            titleMarginTop: '4px',
            iconMarginRight: 1.5,
            rowMarginBottom: 1.5,
            itemMaxWidth: '90px',
            itemPadding: '0 4px'
        }
    }
});

// Full card theme (used in Card.js)
export const fullCardTheme = createTheme({
    ...baseCardTheme,
    card: {
        container: {
            maxWidth: {
                xs: '95%',
                sm: '400px',
                md: '450px',
                lg: '500px',
                xl: '550px'
            },
            padding: '20px'
        },
        profileImage: {
            size: '168px',
            border: '4px solid #ffffff',
            bottom: '-85px',
            padding: '2px',
            margin: '-6px'
        },
        companyLogo: {
            size: '62px',
            bottom: '-75px',
            padding: '4px',
            margin: '-4px',
            rightOffset: 'calc(50% - 105px)',
            leftOffset: '118px'
        },
        portraitLogo: {
            size: '60px',
            top: '50px',
            right: '-50px'
        },
        content: {
            marginTop: {
                portrait: '20px',
                other: '85px'
            },
            padding: '20px'
        },
        typography: {
            nameSize: '1.5rem',
            nameHeight: '36px',
            nameLineHeight: '36px',
            nameMarginBottom: '4px',

            pronounSize: '17px',
            pronounHeight: '24.3px',
            pronounLineHeight: '24.31px',
            pronounMarginTop: '8px',

            jobTitleSize: '1.1875rem',
            jobTitleLineHeight: '1.6981rem',

            locationSize: '1rem',
            locationLineHeight: '1.9rem',

            bioSize: {
                xs: '1rem',
                sm: '1.2rem',
                md: '1.5rem'
            },
            bioLineHeight: {
                xs: '6vh',
                sm: '7vh',
                md: '22.5px'
            },
            bioMargin: {
                top: '1.25rem',
                bottom: {
                    xs: '0',
                    sm: '0.5rem',
                    md: '1rem'
                }
            }
        },
        button: {
            fontSize: '1.1875rem',
            padding: '0.7rem 1rem',
            letterSpacing: '0.034rem',
            marginTop: '20px'
        },
        links: {
            marginTop: 2,
            itemMargin: 1.5,
            itemMarginBottom: 1,
            iconSize: '55px',
            iconBorderRadius: '14px',
            iconPadding: '5px',
            leftIconSize: '45px',
            leftIconBorderRadius: '7px',
            titleFontSize: '12px',
            leftTitleFontSize: '14px',
            titleMarginTop: '5px',
            iconMarginRight: 2,
            rowMarginBottom: 2,
            itemMaxWidth: '110px',
            itemPadding: '0 5px'
        }
    }
}); 